<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-people'></i> Kartica kupca
						<div class="card-actions">
							<a href="#dodajKupca" class="btn btn-setting" @click.prevent="click_openAddKupec"><i class="icon-user-follow"></i></a>
						</div>
					</div>
					<b-container v-show="false">
						<b-row class="mb-3 justify-content-md-center">
							<b-col></b-col>
							<b-col cols="8">
								<b-form-group label-cols="1" label="Išči" class="mb-0">
									<b-input-group>
										<b-form-input v-model="filter" placeholder="Vnesi iskani niz" />
										<b-input-group-append>
											<b-btn :disabled="!filter" @click="filter = ''">Počisti</b-btn>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
							<b-col></b-col>
						</b-row>
					</b-container>
					<b-table
						ref="dataTable"
						responsive="sm"
						show-empty
						hover
						empty-text="Ni vnosov"
						empty-filtered-text="Ni zadetkov"
						:items="dataProvider"
						:fields="fields"
						:current-page="currentPage"
						:per-page="perPage"
						:filter="filter"
						@row-clicked="rowClicked">
						<template slot="is_company" slot-scope="data">
							{{ data.item.is_company | type_format }}
						</template>
						<template slot="title" slot-scope="data">
							{{ data.item | title_format }}
						</template>
						<template slot="actions" slot-scope="data">
							<b-button size="sm" @click.stop="click_openEditKupec(data, $event.target)" variant="primary" title="Uredi kupca" class="m-1 seznamKupcevIconStyle"><i class="fa fa-edit"></i></b-button>
							<b-button v-if="allowDelete()" size="sm" @click.stop="click_removeKupec(data, $event.target)" variant="danger" title="Izbriši kupca" class="m-1 seznamKupcevIconStyle"><i class="fa fa-remove"></i></b-button>
						</template>
					</b-table>
					<nav>
						<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
					</nav>
				</b-card>
				<edit-kupec-modal ref="editModal" v-model="selectedKupec" @kupec_add="edit_add" @kupec_edit="edit_update" />
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>
<script>
import EditKupecModal from '@/components/EditKupecModal';
import service from '@/service';

export default {
	name: 'kupci',
	components: {
		'edit-kupec-modal': EditKupecModal
	},
	filters: {
		type_format: function (isCompany) {
			if (isCompany) {
				return 'P';
			} else {
				return 'F';
			}
		},
		title_format: function (item) {
			if (item.is_company) {
				return item.title + ' (' + item.contact_name + ')';
			} else {
				return item.first_name + ' ' + item.last_name;
			}
		}
	},
	methods: {
		rowClicked (item, index) {
			this.selectedKupec = item;
			this.$refs.editModal.openModal();
		},
		click_openAddKupec: function () {
			this.selectedKupec = null;
			this.$refs.editModal.openModal();
		},
		click_openEditKupec: function (data, button) {
			this.selectedKupec = data.item;
			this.$refs.editModal.openModal();
		},
		click_removeKupec: function (data, button) {
			let naziv = '';
			if (data.item.is_company) {
				naziv = data.item.title + ' ' + data.item.contact_name;
			} else {
				naziv = data.item.first_name + ' ' + data.item.first_name;
			}
			this.$bvModal.msgBoxConfirm('Želite izbrisati kupca ' + naziv + '?', {
				title: 'Potrdite brisanje kupca',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					service.removeKupec(data.item)
						.then(kupec => {
							this.$refs.dataTable.refresh();
							this.$refs.toastr.s('Kupec ' + data.item.first_name + ' ' + data.item.last_name + ' odstranjen');
						})
						.catch(error => {
							if (error) {
								console.log(error);
							}
						});
				}
			}).catch(err => {
				console.log(err);
			})
		},
		edit_add: function (item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Kupec ' + item.first_name + ' ' + item.last_name + ' dodan');
		},
		edit_update: function (item) {
			this.$refs.dataTable.refresh();
			this.$refs.toastr.s('Kupec ' + item.first_name + ' ' + item.last_name + ' posodobljen');
		},
		dataProvider: function (ctx) {
			return service.getKupciFiltered(ctx, this.filter)
				.then(data => {
					this.items = data;
					this.totalRows = data.total;
					return this.items.data;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
					return [];
				});
		},
		allowDelete: function () {
			if (this.user.role === 4 || this.user.role === 5) {
				return true;
			} else {
				return false;
			}
		}
	},
	data: () => {
		return {
			fields: [
				{ key: 'is_company', label: 'Tip', sortable: true, class: 'seznamKupcevTip' },
				{ key: 'title', label: 'Naziv', sortable: true },
				{ key: 'email', label: 'Email', sortable: true },
				{ key: 'phone_number', label: 'Telefon', sortable: true, class: 'seznamKupcevTelefon' },
				{ key: 'actions', label: '#', class: 'seznamKupcevActions' }
			],
			selectedKupec: null,
			currentPage: 1,
			perPage: 50,
			totalRows: 0,
			items: [],
			filter: null
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		}
	}
};
</script>
<style>
.seznamKupcevTip {
	width: 60px;
}
.seznamKupcevTelefon {
	width: 120px;
}
.seznamKupcevActions {
	width: 120px;
}
.seznamKupcevIconStyle {
	min-width: 35px;
}
</style>



// WEBPACK FOOTER //
// src/views/Kupci.vue